export var EMPTY_DIFF = {
    added: [],
    removed: [],
};
export var applyDiff = function (list, diffs) {
    return diffs.reduce(function (acc, diff) {
        return applyDiffSingle(acc, diff);
    }, list);
};
var applyDiffSingle = function (list, diff) {
    if (!diff) {
        return list;
    }
    var realDiff = diff;
    if (Array.isArray(diff)) {
        realDiff = convertToListDiff(diff, list);
    }
    return list
        .filter(function (item) {
        if (typeof item === 'string') {
            return !realDiff.removed.includes(item);
        }
        else if (typeof item === 'object' && 'value' in item) {
            return !realDiff.removed.includes(item.value);
        }
        return false;
    })
        .concat(realDiff.added);
};
var listContains = function (list, item) {
    if (list.length === 0) {
        return false;
    }
    for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
        var listItem = list_1[_i];
        if (typeof listItem === 'string') {
            if (listItem === item) {
                return true;
            }
        }
        else {
            if (listItem.value === item) {
                return true;
            }
        }
    }
    return false;
};
export var convertToListDiff = function (valuesToDiff, inputDefaults) {
    if (inputDefaults.length === 0) {
        return {
            added: convertOptionsToStrings(valuesToDiff),
            removed: [],
        };
    }
    var added = convertOptionsToStrings(valuesToDiff.filter(function (item) {
        return !listContains(inputDefaults, typeof item === 'string' ? item : item.value);
    }));
    var removed = inputDefaults
        .map(function (item) {
        if (typeof item === 'string') {
            return item;
        }
        return item.value;
    })
        .filter(function (item) { return !listContains(valuesToDiff, item); });
    return { added: added, removed: removed };
};
export var convertOptionsToStrings = function (list) {
    return list.map(function (item) {
        if (typeof item === 'string') {
            return item;
        }
        return item.value;
    });
};
